/**
 * The count that sits under the Staff title.
 *
 * Reports the filtered count against the total whenever a filter is hiding
 * someone, because "5 Staff Members" over a roster of twelve would read as the
 * organization only having five. Empty for an organization with no staff at
 * all — the tab already says so in words, and "0 Staff Members" adds nothing.
 */
export const staffCountLabel = (visible: number, total: number): string => {
  if (total === 0) {
    return ''
  }
  const noun = total === 1 ? 'Staff Member' : 'Staff Members'
  return visible === total ? `${total} ${noun}` : `${visible} of ${total} ${noun}`
}
